"use client"

import { MagnifyingGlassMini } from "@medusajs/icons"
import { useParams, useRouter } from "next/navigation"
import { useState } from "react"

const SearchBox = () => {
  const router = useRouter()
  const { countryCode } = useParams()
  const [query, setQuery] = useState("")

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const q = query.trim()

    if (!q) {
      return
    }

    router.push(`/${countryCode}/store?q=${encodeURIComponent(q)}`)
  }

  return (
    <form
      role="search"
      onSubmit={handleSubmit}
      className="relative w-full max-w-[280px]"
      data-testid="nav-search-form"
    >
      <input
        type="search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search parts..."
        aria-label="Search parts"
        className="w-full h-9 rounded-full bg-grey-80 border border-grey-70 pl-4 pr-10 text-white placeholder:text-grey-40 focus:outline-none focus:border-amber-500 transition-colors"
        data-testid="nav-search-input"
      />
      <button
        type="submit"
        aria-label="Search"
        className="absolute right-1 top-1/2 -translate-y-1/2 flex h-7 w-7 items-center justify-center rounded-full text-grey-40 hover:text-white transition-colors"
        data-testid="nav-search-submit"
      >
        <MagnifyingGlassMini aria-hidden="true" />
      </button>
    </form>
  )
}

export default SearchBox
